import type { DashboardAnalytics, SeoAnalytics } from "@/domain/models/analytics";
import type { AnalyticsRepository } from "@/domain/repositories/analytics.repository";
import {
  bodyDistribution,
  brandDistribution,
  coreWebVitals,
  dailyTraffic,
  funnelStages,
  keywordRankings,
  revenueByMonth,
  topVehicles,
  trafficSources,
} from "@/data/admin";
import { delay } from "@/infrastructure/repositories/mock/delay";

export class MockAnalyticsRepository implements AnalyticsRepository {
  async getDashboard(): Promise<DashboardAnalytics> {
    await delay();
    return {
      dailyTraffic: dailyTraffic.map((point) => ({ ...point })),
      revenueByMonth: revenueByMonth.map((point) => ({ ...point })),
      brandDistribution: brandDistribution.map((point) => ({ ...point })),
      bodyDistribution: bodyDistribution.map((point) => ({ ...point })),
      topVehicles: topVehicles.map((point) => ({ ...point })),
      trafficSources: trafficSources.map((point) => ({ ...point })),
      funnelStages: funnelStages.map((point) => ({ ...point })),
    };
  }

  async getSeo(): Promise<SeoAnalytics> {
    await delay();
    return {
      keywordRankings: keywordRankings.map((row) => ({ ...row })),
      coreWebVitals: { ...coreWebVitals },
    };
  }
}
